
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "delete-transactions-tabs",
  components: {},
})
export class DeleteTransactionsTabs extends Vue {
  titleRegisterSolution = this.$t("support_panel.tab.title.massive_operations");
}
export default DeleteTransactionsTabs;
